// Import

// eslint-disable-next-line import/prefer-default-export
export const baseUrl = process.env.REACT_APP_API_HOST;
export const gTagID = process.env.REACT_APP_GOOGLE_ANALYTICS_TAG;
// eslint-disable-next-line import/prefer-default-export
// export const baseUrl = process.env.APIHOST;
